//new
export class Step {
    conf: string;
    name: string;
    title: string;
    then: Array<Step>;
    if: Array<Condition>;
}

export class Condition {
    param: string;
    value: string;
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/steps.ts